import React from "react"
import { Navigate, useLocation, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { pickDefaultCityHubCity } from "./cityHubCity"
import { cityHubShadowEventPath } from "./cityHubTabs"

/**
 * Legacy deep link — `/city-hub/events/:eventId`
 * Redirects into the City Hub shadow events tab (layout + listing chrome).
 */
const CityHubEventDetail = () => {
  const { eventId } = useParams()
  const location = useLocation()
  const currentUser = useSelector(state => state.auth.currentUser)
  const city = location.state?.city || pickDefaultCityHubCity(currentUser)

  if (!eventId || !city?.id) {
    return <Navigate to="/city-hub" replace />
  }

  return (
    <Navigate
      to={cityHubShadowEventPath(city.id, eventId)}
      replace
      state={location.state}
    />
  )
}

export default CityHubEventDetail
